export default __webpack_public_path__ + "static/media/Ilustracion-inicio.55ed5257.png";